export const publicSharingOptions = {
  READ: 'read',
  EDIT: 'edit',
}
export const publicSharingOptionsMap = {
  [publicSharingOptions.EDIT]: {
    title: 'Edit',
    inlineText: 'edit this doc',
    description: 'Can add, delete & update content',
  },
  [publicSharingOptions.READ]: {
    title: 'Read',
    inlineText: 'read this doc',
    description: 'Can view content only',
  },
}
